module.exports = __webpack_public_path__ + "static/media/logoabastek.aa099445.png";